import { __assign } from "tslib";
// tslint:disable-next-line:max-line-length
import { createFakeGetResponder, createFakePostResponder, createFakeDeleteResponder, createFakePutResponder } from '../../test-utils';
import { createHttpTestKit } from '../../http/test-kit';
import { createWebhooksApi } from './index';
export var createWebhooksApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createWebhooksApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetWebhooks: function () { return createFakeGetResponder(fakeHttp, '/webhooks'); },
        whenAddWebhook: function (dto) { return createFakePostResponder(fakeHttp, '/webhooks')(dto); },
        whenUpdateWebhook: function (dto) {
            return createFakePutResponder(fakeHttp, "/webhooks/" + dto.id)(dto.data);
        },
        whenDeleteWebhook: function (id) { return createFakeDeleteResponder(fakeHttp, "/webhooks/" + id); }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map